import type { MediaItem } from "@/types/media";

export const mediaItems: MediaItem[] = [
  {
    id: "changfeng-dukou",
    title: "长风渡口",
    type: "电视剧",
    year: 2024,
    region: "内地",
    rating: 9.1,
    genres: ["剧情", "历史", "年代"],
    director: "沈砚舟",
    actors: ["陆知远", "苏清晚", "程牧云"],
    synopsis:
      "民国初年，渡口小镇的船家少年与留学归来的女学生相遇，一段横跨二十年的家国往事在滚滚江水中展开。",
    description: [
      "《长风渡口》以一条连接南北的古渡为线索，讲述了民国初年渡口小镇上几户人家的命运沉浮。船家少年陈渡（陆知远 饰）自幼在江边长大，撑船、渡人、看尽往来客，直到留学归来的女学生林晚（苏清晚 饰）带着新思想回到镇上。",
      "剧集用细腻的笔触勾勒出时代交替下的众生相：守旧的船行老板、激进的报社青年、沉默的码头工人，每个人都在新旧观念的碰撞中寻找自己的出路。主线围绕陈渡与林晚共同守护渡口、兴办学堂、抵抗水匪的故事层层推进。",
      "镜头语言极具诗意，晨雾中的江面、黄昏里的乌篷船、冬夜码头的点点渔火，构成了一幅流动的水乡画卷。全剧没有夸张的戏剧冲突，而是用克制的叙事让观众沉浸式地走进那段岁月。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20riverside%20ferry%20town%20at%20golden%20dusk%2C%20lone%20boatman%20silhouette%20on%20misty%20river%2C%20epic%20historical%20drama%20poster%20art%2C%20warm%20amber%20and%20deep%20teal%20tones%2C%20painterly%20cinematic%20illustration&width=600&height=900&seq=tangxin-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20ancient%20Chinese%20ferry%20town%20at%20misty%20dawn%2C%20wooden%20boats%20on%20calm%20river%2C%20warm%20golden%20haze%2C%20historical%20drama%20film%20still%20with%20soft%20light&width=1200&height=675&seq=tangxin-still-01&orientation=landscape",
    meta: "40集 · 剧情年代",
    hot: 9850,
  },
  {
    id: "dushi-fusheng-ji",
    title: "都市浮生记",
    type: "电视剧",
    year: 2025,
    region: "内地",
    rating: 8.6,
    genres: ["都市", "情感", "职场"],
    director: "何蔚然",
    actors: ["周念安", "林知夏", "许晏清"],
    synopsis:
      "三位在写字楼里打拼的年轻人，在理想与现实之间反复拉扯，用一年的时间重新定义自己想要的生活。",
    description: [
      "《都市浮生记》聚焦大城市里普通年轻人的生活切片。广告公司的策划周念安（周念安 饰）在接连不断的提案与加班中逐渐迷失，合租室友林知夏（林知夏 饰）则辞去稳定工作转行做独立设计师，而创业失败的程序员许晏清（许晏清 饰）不得不重新回到职场。",
      "三条人物线在一间合租屋里交汇，他们互相扶持、彼此嫌弃，又在深夜的出租屋里分享一碗泡面。剧集没有回避现实的残酷，但始终保留了善意和温度：一次意外的加班、一场说走就走的短途旅行、一句笨拙的道歉，都可能成为改变的起点。",
      "整部剧节奏轻快，对话鲜活，大量生活化的细节让观众极易代入。它讲的不是逆袭爽文，而是在快节奏都市里如何与平凡的自己和解。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20metropolitan%20skyline%20at%20night%2C%20young%20professional%20walking%20through%20neon-lit%20city%20street%2C%20urban%20romance%20drama%20poster%2C%20deep%20navy%20and%20warm%20orange%20contrast%2C%20cinematic%20illustration&width=600&height=900&seq=tangxin-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20night%20city%20skyline%20with%20warm%20window%20lights%20and%20wet%20streets%2C%20modern%20urban%20drama%20scene%2C%20moody%20navy%20and%20amber%20tones%2C%20cinematic%20film%20still&width=1200&height=675&seq=tangxin-still-02&orientation=landscape",
    meta: "36集 · 都市生活",
    hot: 8730,
  },
  {
    id: "wudu-mian",
    title: "雾都迷案",
    type: "电视剧",
    year: 2024,
    region: "内地",
    rating: 8.9,
    genres: ["悬疑", "犯罪", "推理"],
    director: "傅寒声",
    actors: ["江徹", "温瑜", "裴景行"],
    synopsis:
      "连续发生的离奇案件都指向一份十年前封存的档案，退休刑警与年轻检察官联手揭开被大雾笼罩的真相。",
    description: [
      "《雾都迷案》以一座常年被浓雾笼罩的南方城市为背景。退休多年的老刑警江徹（江徹 饰）因为一起模仿作案被重新请回，与擅长逻辑推理的年轻检察官温瑜（温瑜 饰）组成了年龄与风格都格格不入的搭档。",
      "随着调查深入，两人发现所有案件都与十年前一桩被草草结案的旧案有关，而当年的卷宗早已被封存。剧集采用双线叙事，一条线是当下的追查，另一条线通过闪回还原十年前的真相，两条线在最后几集交汇，带来强烈的情感冲击。",
      "全剧的悬疑氛围营造堪称一流，湿漉漉的街道、昏黄的路灯、若隐若现的脚步声，都让观众全程紧绷。而案件背后关于正义、亲情与救赎的探讨，让这部悬疑剧不止于解谜。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Foggy%20old%20city%20street%20with%20detective%20silhouette%20under%20streetlamp%2C%20moody%20crime%20thriller%20poster%2C%20dark%20teal%20fog%20and%20warm%20lamp%20glow%2C%20mysterious%20cinematic%20illustration&width=600&height=900&seq=tangxin-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20foggy%20night%20city%20street%20with%20lone%20detective%20figure%2C%20teal%20mist%20and%20amber%20streetlamp%20light%2C%20crime%20thriller%20film%20noir%20still&width=1200&height=675&seq=tangxin-still-03&orientation=landscape",
    meta: "32集 · 悬疑推理",
    hot: 9120,
  },
  {
    id: "xinghe-bian",
    title: "星河彼岸",
    type: "电视剧",
    year: 2025,
    region: "内地",
    rating: 8.3,
    genres: ["科幻", "爱情", "冒险"],
    director: "骆明轩",
    actors: ["叶星野", "顾南枝", "沈屿"],
    synopsis:
      "一名星际领航员与地球上的植物学家隔着数百光年通信，两颗孤独的心在漫长等待中靠近。",
    description: [
      "《星河彼岸》设定在人类开始星际移民的近未来。领航员叶星野（叶星野 饰）随远征舰队飞往遥远星系，而植物学家顾南枝（顾南枝 饰）留在地球负责培育失传的作物。由于通信延迟，两人之间的一封信息需要数年才能抵达，他们的感情就建立在这些迟到的对话之上。",
      "剧集用极具想象力的视觉呈现了宇宙的浩瀚：旋转的星云、废弃的空间站、飘满尘埃的驾驶舱。但真正打动人的是其中细腻的情感描写——等待、误解、坚持与重逢，被拉长到宇宙尺度后变得更加强烈。",
      "除了爱情线，剧集还探讨了人类在拓展生存空间时对故土的眷恋。当叶星野最终在星空中看到地球的蓝点时，那份触动足以让每个观众重新审视脚下的家园。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20above%20a%20glowing%20planet%2C%20two%20figures%20reaching%20toward%20each%20other%2C%20science%20fiction%20romance%20poster%2C%20cosmic%20gold%20and%20indigo%20nebula%2C%20cinematic%20illustration&width=600&height=900&seq=tangxin-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20shot%20of%20a%20glowing%20planet%20with%20starship%20silhouette%2C%20cosmic%20nebula%20in%20gold%20and%20indigo%2C%20cinematic%20science%20fiction%20film%20still&width=1200&height=675&seq=tangxin-still-04&orientation=landscape",
    meta: "30集 · 科幻爱情",
    hot: 7640,
  },
  {
    id: "shanye-laixin",
    title: "山野来信",
    type: "电视剧",
    year: 2023,
    region: "内地",
    rating: 8.8,
    genres: ["田园", "治愈", "剧情"],
    director: "苏木",
    actors: ["简禾", "陆迟", "阿桃"],
    synopsis:
      "城市白领回到故乡山村经营一家旧邮局，在一封封往来信件中重新找回了生活的节奏。",
    description: [
      "《山野来信》讲述设计师简禾（简禾 饰）在经历了一次重大的事业挫折后，回到阔别多年的故乡，接手了爷爷留下的一间老邮局。原本只想短暂停留的她，却在整理信件的过程中，慢慢被这座小山村和村里的人留住。",
      "剧集没有激烈的矛盾冲突，而是用舒缓的节奏记录四季流转：春天的油菜花田、夏夜的萤火虫、秋天的晒谷场、冬日的围炉夜话。每一集围绕几封信展开，讲述寄信人与收信人之间的温暖故事。",
      "老邮局、石板路、炊烟袅袅的屋檐……这些画面配合手写信特有的温度，构成了一部让人静下心来的治愈剧。它提醒我们，生活的答案有时候就藏在那些慢下来的时刻里。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Peaceful%20countryside%20village%20at%20golden%20hour%2C%20winding%20path%20through%20green%20hills%2C%20gentle%20rural%20healing%20drama%20poster%2C%20soft%20green%20and%20warm%20cream%20tones%2C%20pastel%20painterly&width=600&height=900&seq=tangxin-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Tranquil%20green%20mountain%20village%20with%20stone%20path%20and%20gentle%20morning%20light%2C%20peaceful%20rural%20scene%2C%20soft%20green%20pastel%20tones%2C%20cinematic%20film%20still&width=1200&height=675&seq=tangxin-still-05&orientation=landscape",
    meta: "24集 · 田园治愈",
    hot: 6890,
  },
  {
    id: "jianghu-yeyu-lu",
    title: "江湖夜雨录",
    type: "电视剧",
    year: 2024,
    region: "内地",
    rating: 9.0,
    genres: ["武侠", "古装", "动作"],
    director: "戚长风",
    actors: ["燕无归", "白露", "楚墨"],
    synopsis:
      "一代剑客隐姓埋名退隐江湖，却因一桩旧案被迫重出，在雨夜中直面自己不愿提起的过往。",
    description: [
      "《江湖夜雨录》是一部气质冷峻的新派武侠剧。主角燕无归（燕无归 饰）曾是名震天下的剑客，如今在一座小镇上以打铁为生。直到当年同袍的女儿白露（白露 饰）带着一封血书找上门来，尘封的往事被迫重新揭开。",
      "剧集的武打设计摒弃了夸张的特效，转而追求写实与意境，雨中对决、屋檐追逐、竹林伏击等桥段都被拍得极具电影质感。每一场打斗不仅是动作的碰撞，更是人物情绪与立场的交锋。",
      "在江湖的刀光剑影之外，剧集探讨的其实是放下与执念。燕无归能否放下手中之剑、能否放过自己，构成了全剧最动人的主线。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20warrior%20standing%20on%20tiled%20rooftop%20in%20night%20rain%20with%20sword%2C%20ancient%20Chinese%20martial%20arts%20poster%2C%20ink-wash%20style%2C%20teal%20night%20and%20warm%20lantern%20glow&width=600&height=900&seq=tangxin-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20rooftops%20under%20rainy%20night%20sky%20with%20lanterns%20glowing%2C%20wuxia%20martial%20arts%20scene%2C%20teal%20and%20amber%20tones%2C%20cinematic%20film%20still&width=1200&height=675&seq=tangxin-still-06&orientation=landscape",
    meta: "38集 · 武侠古装",
    hot: 9450,
  },
  {
    id: "wusheng-zhihai",
    title: "无声之海",
    type: "电影",
    year: 2025,
    region: "内地",
    rating: 8.7,
    genres: ["剧情", "悬疑"],
    director: "陆沉",
    actors: ["卫然", "陶然"],
    synopsis:
      "一名失去记忆的潜水员在一座无人的海岛醒来，为了找回自己，他必须潜入那片吞噬了一切的海。",
    description: [
      "《无声之海》是一部氛围感极强的悬疑剧情片。男主角（卫然 饰）在一座荒岛上醒来，身边只有一件破损的潜水服和一枚陌生的戒指。他记不起自己是谁，也不知道为何会出现在这里，唯一能确定的是——海里有答案。",
      "影片用大量的空镜头与长镜头构建出令人窒息的孤独感。海浪拍打礁石的声音、风穿过废弃小屋的呜咽、以及主角在水下逐渐模糊的呼吸声，共同编织出一场关于记忆与身份的迷局。",
      "随着一次次的潜水，零碎的记忆碎片逐渐拼凑完整，真相却比想象中更加沉重。影片的结尾留白意味深长，让观众在沉默中反复咀嚼。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Lone%20figure%20standing%20on%20vast%20empty%20beach%20under%20overcast%20sky%2C%20silent%20mystery%20film%20poster%2C%20muted%20grey-blue%20sea%20and%20pale%20sand%2C%20minimalist%20cinematic%20composition&width=600&height=900&seq=tangxin-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20empty%20beach%20with%20calm%20grey%20sea%20under%20overcast%20sky%2C%20lone%20figure%20walking%20in%20distance%2C%20minimalist%20moody%20film%20still&width=1200&height=675&seq=tangxin-still-07&orientation=landscape",
    meta: "118分钟 · 悬疑剧情",
    hot: 8210,
  },
  {
    id: "zhuiguang-zhe",
    title: "追光者",
    type: "电影",
    year: 2024,
    region: "内地",
    rating: 8.4,
    genres: ["励志", "剧情", "运动"],
    director: "路遥",
    actors: ["陈醒", "何苗"],
    synopsis:
      "一位失去一条腿的年轻人在清晨的跑道上重新出发，他用三年的时间跑向了曾经不敢想的地方。",
    description: [
      "《追光者》根据真实故事改编，讲述短跑运动员陈醒（陈醒 饰）因意外失去右腿后，从绝望中走出，安装上运动义肢重新站上赛道的过程。陪伴他的是固执的老教练何苗（何苗 饰），一个同样被生活磨砺却从未低头的人。",
      "影片没有回避康复训练的枯燥与疼痛，也真实呈现了旁人的质疑与自我的动摇。但正是那些一次次摔倒后重新站起来的瞬间，让“追光”这两个字有了分量。",
      "清晨空旷的跑道、逆光中的奔跑剪影、被汗水浸透的训练服，构成了影片最有力量的视觉记忆。它告诉观众，光不一定在前方，也可能来自不肯停下的自己。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Silhouetted%20runner%20sprinting%20toward%20warm%20sunrise%20on%20open%20road%2C%20inspirational%20sports%20drama%20film%20poster%2C%20golden%20orange%20sky%20and%20dark%20silhouette%2C%20hopeful%20cinematic&width=600&height=900&seq=tangxin-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Runner%20silhouette%20sprinting%20toward%20glowing%20sunrise%20on%20empty%20road%2C%20warm%20golden%20backlight%2C%20inspirational%20film%20still%20with%20long%20shadows&width=1200&height=675&seq=tangxin-still-08&orientation=landscape",
    meta: "126分钟 · 励志运动",
    hot: 7130,
  },
  {
    id: "shijian-zhouzhe",
    title: "时间褶皱",
    type: "电影",
    year: 2025,
    region: "美国",
    rating: 8.9,
    genres: ["科幻", "悬疑", "剧情"],
    director: "Arthur Vance",
    actors: ["Ethan Cole", "Mia Rowen"],
    synopsis:
      "物理学家发现时间并非直线，而是可以被折叠的，为了见女儿最后一面，他决定走一条危险的近路。",
    description: [
      "《时间褶皱》是一部硬核又不失温度的科幻电影。物理学家埃文（Ethan Cole 饰）在研究晶体结构时意外发现了“时间褶皱”——只要找到正确的折点，就可以在压缩的时间里穿越更长的距离。",
      "为了挽回一场早已注定的告别，埃文开始一次次尝试折叠时间，却发现自己每改变一次过去，周围的世界就会发生无法预估的连锁反应。影片用精巧的结构把时间悖论演绎得扣人心弦。",
      "视觉上，扭曲的城市天际线、折叠的空间走廊、逆流而下的雨水，构成了一幅幅超现实的画面。而这一切奇观最终都指向一个朴素的命题：有些告别，无法被折叠。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Surreal%20folded%20cityscape%20bending%20through%20a%20glowing%20time%20portal%2C%20science%20fiction%20film%20poster%2C%20amber%20and%20deep%20navy%20geometric%20light%2C%20mind-bending%20cinematic%20illustration&width=600&height=900&seq=tangxin-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Surreal%20folded%20cityscape%20with%20glowing%20geometric%20light%20paths%2C%20amber%20and%20deep%20navy%20tones%2C%20mind-bending%20science%20fiction%20film%20still&width=1200&height=675&seq=tangxin-still-09&orientation=landscape",
    meta: "142分钟 · 科幻悬疑",
    hot: 8990,
  },
  {
    id: "xueluo-changjie",
    title: "雪落长街",
    type: "电影",
    year: 2023,
    region: "日本",
    rating: 8.5,
    genres: ["爱情", "文艺"],
    director: "佐藤涼",
    actors: ["藤井遥", "中村遥"],
    synopsis:
      "下雪的冬夜，两条相交却无法重合的轨迹在一座小城的旧街上留下了短暂的温暖。",
    description: [
      "《雪落长街》是一部安静克制的文艺爱情片。卖唱的青年与书店店员在一场大雪中偶然相遇，他们在旧街的昏黄灯光下走了很久，聊起各自难以言说的生活。",
      "影片几乎没有戏剧化的情节，更多是两个人并肩走路、沉默、以及偶尔的对话。但正是这种留白，让情感的流动显得格外真实。雪、路灯、旧书店、以及呼出的白气，共同构成了一幅温柔的冬夜图景。",
      "结局没有给出明确的答案，两条轨迹在雪停之后各自延续。有人说这是遗憾，也有人觉得这才是生活本来的样子。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Two%20figures%20walking%20apart%20on%20snow-covered%20old%20street%20at%20twilight%2C%20romantic%20art%20film%20poster%2C%20soft%20white%20snow%20and%20warm%20window%20light%2C%20melancholic%20pastel%20tones&width=600&height=900&seq=tangxin-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Snow-covered%20old%20Japanese%20street%20at%20twilight%20with%20warm%20window%20lights%2C%20soft%20falling%20snow%2C%20melancholic%20romantic%20film%20still&width=1200&height=675&seq=tangxin-still-10&orientation=landscape",
    meta: "112分钟 · 文艺爱情",
    hot: 6520,
  },
  {
    id: "tiexue-yuanzheng",
    title: "铁血远征",
    type: "电影",
    year: 2024,
    region: "内地",
    rating: 9.2,
    genres: ["战争", "历史", "剧情"],
    director: "孟山河",
    actors: ["秦剑锋", "郝建国", "白铁军"],
    synopsis:
      "一支被派往最前线的连队在极端的环境下坚守阵地，用信念与热血写下了一段不能被遗忘的历史。",
    description: [
      "《铁血远征》以一场真实的历史战役为背景，聚焦一支普通连队在极端恶劣环境下的坚守。没有脸谱化的英雄，每一个战士都有自己的牵挂与恐惧，但当号角吹响，他们依然选择了向前。",
      "影片在战争场面的还原上投入了巨大心力，漫天的风雪、结冰的战壕、轰鸣的炮火，都以极具沉浸感的方式呈现。而穿插其中的家书与回忆，让观众记住了这些名字背后活生生的人。",
      "全片的气质悲壮而不煽情，它克制地讲述着牺牲与坚守，最后那面在风雪中被高高举起的旗帜，足以让观众肃然起敬。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20battlefield%20at%20dawn%20with%20marching%20soldier%20silhouettes%20and%20distant%20mountains%2C%20war%20history%20film%20poster%2C%20dramatic%20amber%20sky%20and%20dark%20earth%20tones%2C%20grand%20cinematic&width=600&height=900&seq=tangxin-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Grand%20war%20epic%20battlefield%20panorama%20at%20dawn%20with%20marching%20army%20silhouettes%2C%20glowing%20amber%20sunrise%20over%20mountains%2C%20cinematic%20wide%20film%20still&width=1200&height=675&seq=tangxin-still-11&orientation=landscape",
    meta: "150分钟 · 战争历史",
    hot: 9760,
  },
  {
    id: "chengnan-jiumeng",
    title: "城南旧梦",
    type: "电影",
    year: 2022,
    region: "内地",
    rating: 8.6,
    genres: ["文艺", "剧情", "家庭"],
    director: "顾之南",
    actors: ["许安", "林穗"],
    synopsis:
      "一个在外漂泊多年的游子回到城南老巷，在斑驳的院墙与旧物中，重新拼起了整个童年。",
    description: [
      "《城南旧梦》是一部关于记忆与故乡的散文式电影。男主角许安（许安 饰）在母亲去世后回到城南老巷处理旧宅，推开那扇熟悉的木门，童年的往事纷至沓来。",
      "影片用缓缓推进的镜头扫过老巷的每一个角落：墙根的青苔、晾衣绳上的旧衫、邻居窗台的花。这些静物成为时间的注脚，串联起一个家庭几十年的悲欢。",
      "没有激烈的冲突，也没有刻意的煽情，影片用极其温柔的笔触讲述离别与和解。当许安最后锁上旧宅的门，观众也会忍不住想起自己那些回不去的地方。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20old%20Chinese%20alley%20with%20bicycle%20and%20falling%20leaves%2C%20memory%20art%20film%20poster%2C%20warm%20sepia%20and%20soft%20green%20tones%2C%20tender%20painterly%20illustration&width=600&height=900&seq=tangxin-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Nostalgic%20old%20Chinese%20alley%20with%20aged%20walls%20and%20falling%20autumn%20leaves%2C%20warm%20sepia%20light%2C%20tender%20memory%20film%20still&width=1200&height=675&seq=tangxin-still-12&orientation=landscape",
    meta: "105分钟 · 文艺家庭",
    hot: 5980,
  },
  {
    id: "jiye-xingdong",
    title: "极夜行动",
    type: "电影",
    year: 2025,
    region: "内地",
    rating: 8.2,
    genres: ["动作", "谍战", "惊悚"],
    director: "高铮",
    actors: ["沈烈", "Vera Lei"],
    synopsis:
      "在永夜笼罩的北极城市里，一名特工必须在七十二小时内找到内鬼，否则一场灾难将无法避免。",
    description: [
      "《极夜行动》把谍战故事搬到了位于北极圈内的一座城市。长达数月的极夜里，特工沈烈（沈烈 饰）接到一项几乎不可能完成的任务：在七十二小时内揪出潜伏在组织内部的内鬼，阻止一枚装置被激活。",
      "影片节奏紧张，几乎不给人喘息的空间。冰封的街道、昏暗的酒吧、废弃的雷达站，都成为惊险交锋的舞台。反转不断的剧情让观众始终猜不到下一秒会发生什么。",
      "在硬核的动作场面之外，影片也刻画了主角在极度压力下的信任危机——当所有人都可能是敌人时，你还能相信谁？",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Spy%20in%20long%20coat%20walking%20through%20snowy%20arctic%20night%20city%2C%20action%20espionage%20film%20poster%2C%20cold%20steel%20tones%20with%20warm%20red%20accent%20light%2C%20tense%20cinematic&width=600&height=900&seq=tangxin-poster-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Snowy%20arctic%20night%20city%20street%20with%20lone%20figure%20in%20long%20coat%2C%20cold%20steel%20tones%20and%20warm%20red%20accent%20light%2C%20tense%20spy%20thriller%20film%20still&width=1200&height=675&seq=tangxin-still-13&orientation=landscape",
    meta: "134分钟 · 动作谍战",
    hot: 8450,
  },
  {
    id: "yangguang-li-de-chenai",
    title: "阳光里的尘埃",
    type: "电影",
    year: 2024,
    region: "韩国",
    rating: 8.8,
    genres: ["家庭", "剧情"],
    director: "김민정",
    actors: ["박지훈", "이수현"],
    synopsis:
      "一位固执的父亲与久别重逢的女儿在同一个屋檐下相处了一个夏天，在细碎的日常里慢慢学会了靠近。",
    description: [
      "《阳光里的尘埃》讲述了一段关于父女关系的温情故事。性格固执的父亲独居多年，女儿因工作调动回到家中暂住。两人观念不同、习惯不同，摩擦在所难免。",
      "影片没有设置强烈的外部冲突，所有的情绪都藏在生活细节里：一顿做得过咸的饭、一句欲言又止的关心、一次深夜里为对方留的那盏灯。正是这些微小的瞬间，让隔阂一点点消融。",
      "午后的客厅里，阳光穿过窗户照在漂浮的尘埃上，安静得能听见时间的声音。影片用这样的画面告诉我们，爱有时候不需要说出口，它就在日复一日的陪伴里。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Family%20gathered%20in%20sunlit%20living%20room%20with%20warm%20dust%20motes%20in%20air%2C%20heartfelt%20drama%20film%20poster%2C%20soft%20golden%20light%20and%20warm%20beige%2C%20tender%20cinematic&width=600&height=900&seq=tangxin-poster-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20sunlit%20living%20room%20with%20dust%20motes%20floating%20in%20golden%20light%2C%20cozy%20family%20drama%20scene%2C%20soft%20beige%20tones%2C%20cinematic%20film%20still&width=1200&height=675&seq=tangxin-still-14&orientation=landscape",
    meta: "121分钟 · 家庭剧情",
    hot: 7260,
  },
  {
    id: "xingyu-shaonian",
    title: "星屿少年",
    type: "电影",
    year: 2025,
    region: "内地",
    rating: 8.6,
    genres: ["动画", "冒险", "成长"],
    director: "叶知秋",
    actors: ["配音：陆小舟", "配音：夏木"],
    synopsis:
      "在一座漂浮于星海之上的岛屿，一个少年带着会说话的灯塔出发，去寻找传说中会熄灭的星光。",
    description: [
      "《星屿少年》是一部充满想象力的动画电影。故事发生在一座漂浮于星海之上的岛屿，少年阿屿与一座会说话的灯塔相依为命。当支撑岛屿的星光开始一颗颗熄灭，他决定离开家园，去寻找传说中的光源。",
      "影片构建了一个瑰丽奇妙的世界：由云朵编织的桥梁、会唱歌的鲸鱼、漂浮的陨石森林……每一帧都像一幅精心绘制的插画。而少年一路上的遇见与告别，让这场冒险充满温度。",
      "作为一部动画，它的内核却不止面向儿童。关于勇气、离别与成长的主题，同样能触动成年观众的心。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Animated%20boy%20standing%20on%20a%20floating%20island%20under%20starry%20sky%2C%20whimsical%20animation%20film%20poster%2C%20vivid%20teal%20sea%20and%20golden%20stars%2C%20hand-painted%20anime%20style&width=600&height=900&seq=tangxin-poster-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Whimsical%20animated%20floating%20island%20under%20starry%20night%20sky%2C%20teal%20ocean%20and%20golden%20stars%2C%20hand-painted%20anime%20film%20still&width=1200&height=675&seq=tangxin-still-15&orientation=landscape",
    meta: "108分钟 · 动画冒险",
    hot: 7890,
  },
];